<header class="col-12 header-page">
    <h1 class="header__page__content__title">
        Minhas Solicitações
    </h1>
</header>
<main class="main__content col-xl-12 px-2">
    <form class="col-xl-12 col-lg-12 col-md-12 col-sm-12 main__page__content__form" [formGroup]="formGroup"
        (ngSubmit)="getFilter()">
        <section class="content-form">
            <div class="row">
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="content__form__title__label">Tipo de Solicitação</label>
                    <ng-select bindLabel="description" bindValue="id" placeholder="Status do atendimento"
                        [searchable]="false" [items]="solicitationTypes" formControlName="solicitationTypeId">
                    </ng-select>
                </div>
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="content__form__title__label">Protocolo de Atendimento</label>
                    <input type="number" class="form-control input-form" formControlName="ansProtocol" />
                </div>
            </div>
            <div class="row">
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data Início</label>
                    <input type="date" class="form-control input-form" formControlName="initialDate"
                        placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('initialDate')?.touched && formGroup.get('initialDate')?.invalid">
                        O campo Data inicio está inválido!
                    </small>
                </div>
                <div class="col-xs-6 col-xl-6 col-md-6 col-sm-12 mb-2 px-1">
                    <label class="label-form">Data Término</label>
                    <input type="date" class="form-control input-form" formControlName="finalDate"
                        placeholder="DD-MM-YYYY" max="{{today | date:'yyyy-MM-dd'}}">
                    <small class="form-text text-muted danger ng-star-inserted"
                        *ngIf="formGroup.get('finalDate')?.touched && formGroup.get('finalDate')?.invalid">
                        O campo Data fim está inválido!
                    </small>
                </div>
            </div>
        </section>
        <button class="btn button-primary col-xl-2 col-lg-3 col-md-4 col-sm-12 mr-xl-1 mr-lg-1" type="submit"
            [disabled]="this.loading">
            <div class="d-flex" *ngIf="loading; else showSpan">
                <span> Consultando</span>
            </div>
            <ng-template #showSpan>
                <span>Consultar</span>
            </ng-template>
        </button>
    </form>
    <ng-template #naoPossuiSolicitacoes>
        <ng-container *ngIf="!loading">
            <p class="col-12 ng-template-text">
                Você não possui solicitações!
            </p>
        </ng-container>

    </ng-template>

    <ng-container #showLoading>
        <spinner [show]="loading"></spinner>
      </ng-container>

    <section *ngIf="myRequests && myRequests.items.length > 0 else naoPossuiSolicitacoes">
        <div class="d-none d-md-block">
            <header class="content__header">
                <h3 class="content__resultado__grid__header__title">Solicitações</h3>
                <filtro-dados [pageItens]="5" [totalItens]="myRequests.totalItems"
                    (changeQuantidade)="onChangeQuantidadeItens($event)" />
            </header>
            <main>
                <section class="content__header__table">
                    <div class="col-xl-4">Protocolo de Atendimento</div>
                    <div class="col-xl-3">Data e Hora da Solicitação</div>
                    <div class="col-xl-3">Tipo de Solicitação</div>
                    <div class="col-xl-1 display-sm-none">Situação</div>
                    <div class="col-xl-1">Ações</div>
                </section>
                <section class="content__main__table">
                    <div class="table__card" *ngFor="let item of myRequests.items">
                        <div class="col-xl-4">{{ item.ansProtocol }}</div>
                        <div class="col-xl-3">{{ item.requestDate | date:'dd/MM/yyyy HH:mm' }}</div>
                        <div class="col-xl-3">{{ item.solicitationType.description }}</div>
                        <div class="col-xl-1 display-sm-none">{{ item.status }}</div>
                        <div class="col-xl-1 content-acoes">
                            <fa-icon class="fa-icon" [icon]="faCopy" (click)="copiarTexto(item.ansProtocol)">
                            </fa-icon>
                            <!-- <fa-icon class="fa-icon" [icon]="faEye" (click)="detalhes(item)">
                            </fa-icon> -->
                        </div>
                    </div>
                </section>
            </main>
        </div>

        <section class="d-block d-md-none mt-3">
            <div *ngFor="let item of myRequests.items" class="card mb-4 p-3 shadow-sm border-0 bg-light">
              <div class="row mb-2">
                <div class="col-6">
                  <div class="legenda-card font-weight-bold">Protocolo</div>
                  <div>{{ item.ansProtocol }}</div>
                </div>
                <div class="col-6 text-end">
                  <div class="legenda-card font-weight-bold">Data</div>
                  <div>{{ item.requestDate | date:'dd/MM/yyyy HH:mm' }}</div>
                </div>
              </div>
          
              <div class="row mb-2">
                <div class="col-6">
                  <div class="legenda-card mt-3 font-weight-bold">Tipo</div>
                  <div>{{ item.solicitationType.description }}</div>
                </div>
                <div class="col-6 text-end mt-3">
                  <div class="legenda-card font-weight-bold">Situação</div>
                  <div>{{ item.status }}</div>
                </div>
              </div>
          
              <div class="row">
                <div class="col-12 text-end d-flex justify-content-end">
                  <fa-icon class="fa-icon text-primary" [icon]="faCopy" (click)="copiarTexto(item.ansProtocol)"></fa-icon>
                </div>
              </div>
            </div>
          </section>
          

        <footer>
            <paginacao [currentPage]="formGroup.value.page" [collectionSize]="myRequests.totalItems"
                [pageSize]="formGroup.value.itemsPerPage" (changeNumber)="onChangePagination($event)"
                *ngIf="myRequests?.items">
            </paginacao>
        </footer>
    </section>
</main>